import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';

import { NEW_REQUIREMENT_SELECT_OPTION_CODE } from '../constants/newRequirementSelectOption';
import { IKnmErknmForm } from '../interfaces/IKnmErknmForm';

export const convertRequirementsFormValueToKnmData = (values: IKnmErknmForm): IKnm248['requirements'] => {
  const { requirementsErknm } = values;

  if (!requirementsErknm) {
    return null;
  }
  const requirementsFiltered = requirementsErknm.filter(
    item => item.requirement && item.requirement.code !== NEW_REQUIREMENT_SELECT_OPTION_CODE,
  );

  return requirementsFiltered.map(item => ({
    isObserved: typeof item.isObserved?.value === 'boolean' ? item.isObserved?.value : null,
    note: item.note || null,
    requirement: item.requirement?.value || null,
    guid: item.guid || null,
    dateCreate: item.dateCreate || null,
  }));
};
